import React from 'react';
import { useFramework } from '../contexts/FrameworkContext';
import InsightsContainer from '../components/insights/InsightsContainer';
import { Heading } from '../components/ui/heading';

const InsightDetailPage: React.FC = () => {
  const { framework } = useFramework();
  
  return (
    <div>
      <div className="mb-8">
        <Heading level={1} weight="bold" className="text-3xl mb-2">Regulatory Insight Detail</Heading>
        <p className="text-secondary/70">
          {framework === 'NCD' 
            ? 'Detailed information about AI-generated NCD insight'
            : 'Detailed information about AI-generated TCF insight'
          }
        </p>
      </div>
      
      {/* Display the insight detail view */}
      <InsightsContainer showDetailView={true} />
    </div>
  );
};

export default InsightDetailPage;